"use strict";function loginGovNet$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.loginGovNet$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="net.bjGovApn.loginGovNet";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.5.16"},_a)),exports.loginGovNet$=loginGovNet$,exports.default=loginGovNet$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/net/bjGovApn/loginGovNet.js
// module id = 1085
// module chunks = 106